import SvgIcon from '@mui/material/SvgIcon';
import uniqueId from 'lodash/uniqueId';
import PropTypes from 'prop-types';
const AIQEventTriggers = ({ startColor = 'var(--color-black)', endColor = 'var(--color-black)', ...props }) => {
    const gradientId = uniqueId('people-landing-page-gradient-');
    return (
        <SvgIcon {...props} width="25px" height="25px" viewBox="0 0 25 25">
            <path
                d="M17.3985 4.24217C17.6289 3.70702 17.4571 3.08202 16.9844 2.73827C16.5118 2.39452 15.8672 2.42577 15.4258 2.80858L5.42581 11.5586C5.03519 11.9023 4.89456 12.4531 5.07816 12.9375C5.26175 13.4219 5.7305 13.75 6.25003 13.75H10.6055L7.60159 20.7578C7.37113 21.293 7.543 21.918 8.01566 22.2617C8.48831 22.6055 9.13284 22.5742 9.57425 22.1914L19.5743 13.4414C19.9649 13.0976 20.1055 12.5469 19.9219 12.0625C19.7383 11.5781 19.2735 11.2539 18.75 11.2539H14.3946L17.3985 4.24217Z"
                fill="white"
            />
        </SvgIcon>
    );
};

export default AIQEventTriggers;
AIQEventTriggers.propTypes = {
    startColor: PropTypes.string,
    endColor: PropTypes.string,
};
